/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * IDF Repasses
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CommissionAccessOut,
  CommissionAccessUpdate,
  CommissionAgentOut,
  CommissionAgentUpdate,
  CommissionAttributionIn,
  CommissionBulkIn,
  CommissionContext,
  CommissionPolicyIn,
  CommissionPolicyOut,
  CommissionReconcileApply,
  CommissionReconcileIn,
  CommissionReconcileOut,
  CommissionReport,
  CommissionReportParams,
  CommissionReviewPage,
  CommissionReviewParams,
  CommissionReviewerUser,
  HTTPValidationError
} from '../model';

import { apiClient } from '../../client';




/**
 * @summary Access
 */
export const commissionAccess = (

 signal?: AbortSignal
) => {


      return apiClient<CommissionAccessOut>(
      {url: `/api/commercial-commissions/access`, method: 'GET', signal
    },
      );
    }




export const getCommissionAccessQueryKey = () => {
    return [
    `/api/commercial-commissions/access`
    ] as const;
    }


export const getCommissionAccessQueryOptions = <TData = Awaited<ReturnType<typeof commissionAccess>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionAccess>>> = ({ signal }) => commissionAccess(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionAccessQueryResult = NonNullable<Awaited<ReturnType<typeof commissionAccess>>>
export type CommissionAccessQueryError = unknown


export function useCommissionAccess<TData = Awaited<ReturnType<typeof commissionAccess>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionAccess>>,
          TError,
          Awaited<ReturnType<typeof commissionAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionAccess<TData = Awaited<ReturnType<typeof commissionAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionAccess>>,
          TError,
          Awaited<ReturnType<typeof commissionAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionAccess<TData = Awaited<ReturnType<typeof commissionAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Access
 */

export function useCommissionAccess<TData = Awaited<ReturnType<typeof commissionAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Agents
 */
export const commissionAgents = (

 signal?: AbortSignal
) => {


      return apiClient<CommissionAgentOut[]>(
      {url: `/api/commercial-commissions/agents`, method: 'GET', signal
    },
      );
    }




export const getCommissionAgentsQueryKey = () => {
    return [
    `/api/commercial-commissions/agents`
    ] as const;
    }


export const getCommissionAgentsQueryOptions = <TData = Awaited<ReturnType<typeof commissionAgents>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionAgentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionAgents>>> = ({ signal }) => commissionAgents(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof commissionAgents>>>
export type CommissionAgentsQueryError = unknown


export function useCommissionAgents<TData = Awaited<ReturnType<typeof commissionAgents>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionAgents>>,
          TError,
          Awaited<ReturnType<typeof commissionAgents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionAgents<TData = Awaited<ReturnType<typeof commissionAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionAgents>>,
          TError,
          Awaited<ReturnType<typeof commissionAgents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionAgents<TData = Awaited<ReturnType<typeof commissionAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Agents
 */

export function useCommissionAgents<TData = Awaited<ReturnType<typeof commissionAgents>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionAgents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionAgentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Set Access
 */
export const commissionSetAccess = (
    userId: number,
    commissionAccessUpdate: CommissionAccessUpdate,
 signal?: AbortSignal
) => {


      return apiClient<CommissionAgentOut>(
      {url: `/api/commercial-commissions/access/users/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commissionAccessUpdate, signal
    },
      );
    }



export const getCommissionSetAccessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionSetAccess>>, TError,{userId: number;data: CommissionAccessUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionSetAccess>>, TError,{userId: number;data: CommissionAccessUpdate}, TContext> => {

const mutationKey = ['commissionSetAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionSetAccess>>, {userId: number;data: CommissionAccessUpdate}> = (props) => {
          const {userId,data} = props ?? {};

          return  commissionSetAccess(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionSetAccessMutationResult = NonNullable<Awaited<ReturnType<typeof commissionSetAccess>>>
    export type CommissionSetAccessMutationBody = CommissionAccessUpdate
    export type CommissionSetAccessMutationError = HTTPValidationError

    /**
 * @summary Set Access
 */
export const useCommissionSetAccess = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionSetAccess>>, TError,{userId: number;data: CommissionAccessUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionSetAccess>>,
        TError,
        {userId: number;data: CommissionAccessUpdate},
        TContext
      > => {
      return useMutation(getCommissionSetAccessMutationOptions(options), queryClient);
    }
    /**
 * @summary Reviewer Users
 */
export const commissionReviewerUsers = (

 signal?: AbortSignal
) => {


      return apiClient<CommissionReviewerUser[]>(
      {url: `/api/commercial-commissions/review/users`, method: 'GET', signal
    },
      );
    }




export const getCommissionReviewerUsersQueryKey = () => {
    return [
    `/api/commercial-commissions/review/users`
    ] as const;
    }


export const getCommissionReviewerUsersQueryOptions = <TData = Awaited<ReturnType<typeof commissionReviewerUsers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionReviewerUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionReviewerUsers>>> = ({ signal }) => commissionReviewerUsers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionReviewerUsersQueryResult = NonNullable<Awaited<ReturnType<typeof commissionReviewerUsers>>>
export type CommissionReviewerUsersQueryError = unknown


export function useCommissionReviewerUsers<TData = Awaited<ReturnType<typeof commissionReviewerUsers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReviewerUsers>>,
          TError,
          Awaited<ReturnType<typeof commissionReviewerUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReviewerUsers<TData = Awaited<ReturnType<typeof commissionReviewerUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReviewerUsers>>,
          TError,
          Awaited<ReturnType<typeof commissionReviewerUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReviewerUsers<TData = Awaited<ReturnType<typeof commissionReviewerUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reviewer Users
 */

export function useCommissionReviewerUsers<TData = Awaited<ReturnType<typeof commissionReviewerUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReviewerUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionReviewerUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Review
 */
export const commissionReview = (
    params?: CommissionReviewParams,
 signal?: AbortSignal
) => {


      return apiClient<CommissionReviewPage>(
      {url: `/api/commercial-commissions/review`, method: 'GET',
        params, signal
    },
      );
    }




export const getCommissionReviewQueryKey = (params?: CommissionReviewParams,) => {
    return [
    `/api/commercial-commissions/review`, ...(params ? [params] : [])
    ] as const;
    }


export const getCommissionReviewQueryOptions = <TData = Awaited<ReturnType<typeof commissionReview>>, TError = HTTPValidationError>(params?: CommissionReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionReviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionReview>>> = ({ signal }) => commissionReview(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionReviewQueryResult = NonNullable<Awaited<ReturnType<typeof commissionReview>>>
export type CommissionReviewQueryError = HTTPValidationError


export function useCommissionReview<TData = Awaited<ReturnType<typeof commissionReview>>, TError = HTTPValidationError>(
 params: undefined |  CommissionReviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReview>>,
          TError,
          Awaited<ReturnType<typeof commissionReview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReview<TData = Awaited<ReturnType<typeof commissionReview>>, TError = HTTPValidationError>(
 params?: CommissionReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReview>>,
          TError,
          Awaited<ReturnType<typeof commissionReview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReview<TData = Awaited<ReturnType<typeof commissionReview>>, TError = HTTPValidationError>(
 params?: CommissionReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Review
 */

export function useCommissionReview<TData = Awaited<ReturnType<typeof commissionReview>>, TError = HTTPValidationError>(
 params?: CommissionReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionReviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Set Agent
 */
export const commissionSetAgent = (
    userId: number,
    commissionAgentUpdate: CommissionAgentUpdate,
 signal?: AbortSignal
) => {


      return apiClient<CommissionAgentOut>(
      {url: `/api/commercial-commissions/agents/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commissionAgentUpdate, signal
    },
      );
    }



export const getCommissionSetAgentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionSetAgent>>, TError,{userId: number;data: CommissionAgentUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionSetAgent>>, TError,{userId: number;data: CommissionAgentUpdate}, TContext> => {

const mutationKey = ['commissionSetAgent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionSetAgent>>, {userId: number;data: CommissionAgentUpdate}> = (props) => {
          const {userId,data} = props ?? {};

          return  commissionSetAgent(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionSetAgentMutationResult = NonNullable<Awaited<ReturnType<typeof commissionSetAgent>>>
    export type CommissionSetAgentMutationBody = CommissionAgentUpdate
    export type CommissionSetAgentMutationError = HTTPValidationError

    /**
 * @summary Set Agent
 */
export const useCommissionSetAgent = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionSetAgent>>, TError,{userId: number;data: CommissionAgentUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionSetAgent>>,
        TError,
        {userId: number;data: CommissionAgentUpdate},
        TContext
      > => {
      return useMutation(getCommissionSetAgentMutationOptions(options), queryClient);
    }
    /**
 * @summary Policies
 */
export const commissionPolicies = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<CommissionPolicyOut[]>(
      {url: `/api/commercial-commissions/agents/${userId}/policies`, method: 'GET', signal
    },
      );
    }




export const getCommissionPoliciesQueryKey = (userId: number,) => {
    return [
    `/api/commercial-commissions/agents/${userId}/policies`
    ] as const;
    }


export const getCommissionPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof commissionPolicies>>, TError = HTTPValidationError>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionPoliciesQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionPolicies>>> = ({ signal }) => commissionPolicies(userId, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof commissionPolicies>>>
export type CommissionPoliciesQueryError = HTTPValidationError


export function useCommissionPolicies<TData = Awaited<ReturnType<typeof commissionPolicies>>, TError = HTTPValidationError>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionPolicies>>,
          TError,
          Awaited<ReturnType<typeof commissionPolicies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionPolicies<TData = Awaited<ReturnType<typeof commissionPolicies>>, TError = HTTPValidationError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionPolicies>>,
          TError,
          Awaited<ReturnType<typeof commissionPolicies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionPolicies<TData = Awaited<ReturnType<typeof commissionPolicies>>, TError = HTTPValidationError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Policies
 */

export function useCommissionPolicies<TData = Awaited<ReturnType<typeof commissionPolicies>>, TError = HTTPValidationError>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionPolicies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionPoliciesQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Create Policy
 */
export const commissionCreatePolicy = (
    userId: number,
    commissionPolicyIn: CommissionPolicyIn,
 signal?: AbortSignal
) => {


      return apiClient<CommissionPolicyOut>(
      {url: `/api/commercial-commissions/agents/${userId}/policies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commissionPolicyIn, signal
    },
      );
    }



export const getCommissionCreatePolicyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionCreatePolicy>>, TError,{userId: number;data: CommissionPolicyIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionCreatePolicy>>, TError,{userId: number;data: CommissionPolicyIn}, TContext> => {

const mutationKey = ['commissionCreatePolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionCreatePolicy>>, {userId: number;data: CommissionPolicyIn}> = (props) => {
          const {userId,data} = props ?? {};

          return  commissionCreatePolicy(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionCreatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof commissionCreatePolicy>>>
    export type CommissionCreatePolicyMutationBody = CommissionPolicyIn
    export type CommissionCreatePolicyMutationError = HTTPValidationError

    /**
 * @summary Create Policy
 */
export const useCommissionCreatePolicy = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionCreatePolicy>>, TError,{userId: number;data: CommissionPolicyIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionCreatePolicy>>,
        TError,
        {userId: number;data: CommissionPolicyIn},
        TContext
      > => {
      return useMutation(getCommissionCreatePolicyMutationOptions(options), queryClient);
    }
    /**
 * @summary Report
 */
export const commissionReport = (
    params: CommissionReportParams,
 signal?: AbortSignal
) => {


      return apiClient<CommissionReport>(
      {url: `/api/commercial-commissions/report`, method: 'GET',
        params, signal
    },
      );
    }




export const getCommissionReportQueryKey = (params?: CommissionReportParams,) => {
    return [
    `/api/commercial-commissions/report`, ...(params ? [params] : [])
    ] as const;
    }


export const getCommissionReportQueryOptions = <TData = Awaited<ReturnType<typeof commissionReport>>, TError = HTTPValidationError>(params: CommissionReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionReport>>> = ({ signal }) => commissionReport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionReportQueryResult = NonNullable<Awaited<ReturnType<typeof commissionReport>>>
export type CommissionReportQueryError = HTTPValidationError


export function useCommissionReport<TData = Awaited<ReturnType<typeof commissionReport>>, TError = HTTPValidationError>(
 params: CommissionReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReport>>,
          TError,
          Awaited<ReturnType<typeof commissionReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReport<TData = Awaited<ReturnType<typeof commissionReport>>, TError = HTTPValidationError>(
 params: CommissionReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionReport>>,
          TError,
          Awaited<ReturnType<typeof commissionReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionReport<TData = Awaited<ReturnType<typeof commissionReport>>, TError = HTTPValidationError>(
 params: CommissionReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Report
 */

export function useCommissionReport<TData = Awaited<ReturnType<typeof commissionReport>>, TError = HTTPValidationError>(
 params: CommissionReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Deal
 */
export const commissionDeal = (
    proposalId: number,
 signal?: AbortSignal
) => {


      return apiClient<CommissionContext>(
      {url: `/api/commercial-commissions/deals/${proposalId}`, method: 'GET', signal
    },
      );
    }




export const getCommissionDealQueryKey = (proposalId: number,) => {
    return [
    `/api/commercial-commissions/deals/${proposalId}`
    ] as const;
    }


export const getCommissionDealQueryOptions = <TData = Awaited<ReturnType<typeof commissionDeal>>, TError = HTTPValidationError>(proposalId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionDealQueryKey(proposalId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionDeal>>> = ({ signal }) => commissionDeal(proposalId, signal);





   return  { queryKey, queryFn, enabled: !!(proposalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionDealQueryResult = NonNullable<Awaited<ReturnType<typeof commissionDeal>>>
export type CommissionDealQueryError = HTTPValidationError


export function useCommissionDeal<TData = Awaited<ReturnType<typeof commissionDeal>>, TError = HTTPValidationError>(
 proposalId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionDeal>>,
          TError,
          Awaited<ReturnType<typeof commissionDeal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionDeal<TData = Awaited<ReturnType<typeof commissionDeal>>, TError = HTTPValidationError>(
 proposalId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionDeal>>,
          TError,
          Awaited<ReturnType<typeof commissionDeal>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionDeal<TData = Awaited<ReturnType<typeof commissionDeal>>, TError = HTTPValidationError>(
 proposalId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Deal
 */

export function useCommissionDeal<TData = Awaited<ReturnType<typeof commissionDeal>>, TError = HTTPValidationError>(
 proposalId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionDeal>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionDealQueryOptions(proposalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Surgery
 */
export const commissionSurgery = (
    surgeryId: number,
 signal?: AbortSignal
) => {


      return apiClient<CommissionContext>(
      {url: `/api/commercial-commissions/surgeries/${surgeryId}`, method: 'GET', signal
    },
      );
    }




export const getCommissionSurgeryQueryKey = (surgeryId: number,) => {
    return [
    `/api/commercial-commissions/surgeries/${surgeryId}`
    ] as const;
    }


export const getCommissionSurgeryQueryOptions = <TData = Awaited<ReturnType<typeof commissionSurgery>>, TError = HTTPValidationError>(surgeryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommissionSurgeryQueryKey(surgeryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commissionSurgery>>> = ({ signal }) => commissionSurgery(surgeryId, signal);





   return  { queryKey, queryFn, enabled: !!(surgeryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommissionSurgeryQueryResult = NonNullable<Awaited<ReturnType<typeof commissionSurgery>>>
export type CommissionSurgeryQueryError = HTTPValidationError


export function useCommissionSurgery<TData = Awaited<ReturnType<typeof commissionSurgery>>, TError = HTTPValidationError>(
 surgeryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionSurgery>>,
          TError,
          Awaited<ReturnType<typeof commissionSurgery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionSurgery<TData = Awaited<ReturnType<typeof commissionSurgery>>, TError = HTTPValidationError>(
 surgeryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof commissionSurgery>>,
          TError,
          Awaited<ReturnType<typeof commissionSurgery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommissionSurgery<TData = Awaited<ReturnType<typeof commissionSurgery>>, TError = HTTPValidationError>(
 surgeryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Surgery
 */

export function useCommissionSurgery<TData = Awaited<ReturnType<typeof commissionSurgery>>, TError = HTTPValidationError>(
 surgeryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commissionSurgery>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommissionSurgeryQueryOptions(surgeryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Attribute Deal
 */
export const commissionAttributeDeal = (
    proposalId: number,
    commissionAttributionIn: CommissionAttributionIn,
 signal?: AbortSignal
) => {


      return apiClient<CommissionContext>(
      {url: `/api/commercial-commissions/attributions/proposals/${proposalId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commissionAttributionIn, signal
    },
      );
    }



export const getCommissionAttributeDealMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeDeal>>, TError,{proposalId: number;data: CommissionAttributionIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeDeal>>, TError,{proposalId: number;data: CommissionAttributionIn}, TContext> => {

const mutationKey = ['commissionAttributeDeal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionAttributeDeal>>, {proposalId: number;data: CommissionAttributionIn}> = (props) => {
          const {proposalId,data} = props ?? {};

          return  commissionAttributeDeal(proposalId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionAttributeDealMutationResult = NonNullable<Awaited<ReturnType<typeof commissionAttributeDeal>>>
    export type CommissionAttributeDealMutationBody = CommissionAttributionIn
    export type CommissionAttributeDealMutationError = HTTPValidationError

    /**
 * @summary Attribute Deal
 */
export const useCommissionAttributeDeal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeDeal>>, TError,{proposalId: number;data: CommissionAttributionIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionAttributeDeal>>,
        TError,
        {proposalId: number;data: CommissionAttributionIn},
        TContext
      > => {
      return useMutation(getCommissionAttributeDealMutationOptions(options), queryClient);
    }
    /**
 * @summary Attribute Surgery
 */
export const commissionAttributeSurgery = (
    surgeryId: number,
    commissionAttributionIn: CommissionAttributionIn,
 signal?: AbortSignal
) => {


      return apiClient<CommissionContext>(
      {url: `/api/commercial-commissions/attributions/surgeries/${surgeryId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commissionAttributionIn, signal
    },
      );
    }



export const getCommissionAttributeSurgeryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeSurgery>>, TError,{surgeryId: number;data: CommissionAttributionIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeSurgery>>, TError,{surgeryId: number;data: CommissionAttributionIn}, TContext> => {

const mutationKey = ['commissionAttributeSurgery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionAttributeSurgery>>, {surgeryId: number;data: CommissionAttributionIn}> = (props) => {
          const {surgeryId,data} = props ?? {};

          return  commissionAttributeSurgery(surgeryId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionAttributeSurgeryMutationResult = NonNullable<Awaited<ReturnType<typeof commissionAttributeSurgery>>>
    export type CommissionAttributeSurgeryMutationBody = CommissionAttributionIn
    export type CommissionAttributeSurgeryMutationError = HTTPValidationError

    /**
 * @summary Attribute Surgery
 */
export const useCommissionAttributeSurgery = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeSurgery>>, TError,{surgeryId: number;data: CommissionAttributionIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionAttributeSurgery>>,
        TError,
        {surgeryId: number;data: CommissionAttributionIn},
        TContext
      > => {
      return useMutation(getCommissionAttributeSurgeryMutationOptions(options), queryClient);
    }
    /**
 * @summary Attribute Bulk
 */
export const commissionAttributeBulk = (
    commissionBulkIn: CommissionBulkIn,
 signal?: AbortSignal
) => {


      return apiClient<CommissionContext[]>(
      {url: `/api/commercial-commissions/attributions/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commissionBulkIn, signal
    },
      );
    }



export const getCommissionAttributeBulkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeBulk>>, TError,{data: CommissionBulkIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeBulk>>, TError,{data: CommissionBulkIn}, TContext> => {

const mutationKey = ['commissionAttributeBulk'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionAttributeBulk>>, {data: CommissionBulkIn}> = (props) => {
          const {data} = props ?? {};

          return  commissionAttributeBulk(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionAttributeBulkMutationResult = NonNullable<Awaited<ReturnType<typeof commissionAttributeBulk>>>
    export type CommissionAttributeBulkMutationBody = CommissionBulkIn
    export type CommissionAttributeBulkMutationError = HTTPValidationError

    /**
 * @summary Attribute Bulk
 */
export const useCommissionAttributeBulk = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionAttributeBulk>>, TError,{data: CommissionBulkIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionAttributeBulk>>,
        TError,
        {data: CommissionBulkIn},
        TContext
      > => {
      return useMutation(getCommissionAttributeBulkMutationOptions(options), queryClient);
    }
    /**
 * @summary Preview
 */
export const commissionPreview = (
    commissionReconcileIn: CommissionReconcileIn,
 signal?: AbortSignal
) => {


      return apiClient<CommissionReconcileOut>(
      {url: `/api/commercial-commissions/reconciliation/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commissionReconcileIn, signal
    },
      );
    }



export const getCommissionPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionPreview>>, TError,{data: CommissionReconcileIn}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionPreview>>, TError,{data: CommissionReconcileIn}, TContext> => {

const mutationKey = ['commissionPreview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionPreview>>, {data: CommissionReconcileIn}> = (props) => {
          const {data} = props ?? {};

          return  commissionPreview(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof commissionPreview>>>
    export type CommissionPreviewMutationBody = CommissionReconcileIn
    export type CommissionPreviewMutationError = HTTPValidationError

    /**
 * @summary Preview
 */
export const useCommissionPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionPreview>>, TError,{data: CommissionReconcileIn}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionPreview>>,
        TError,
        {data: CommissionReconcileIn},
        TContext
      > => {
      return useMutation(getCommissionPreviewMutationOptions(options), queryClient);
    }
    /**
 * @summary Apply
 */
export const commissionApply = (
    commissionReconcileApply: CommissionReconcileApply,
 signal?: AbortSignal
) => {


      return apiClient<CommissionReconcileOut>(
      {url: `/api/commercial-commissions/reconciliation/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commissionReconcileApply, signal
    },
      );
    }



export const getCommissionApplyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionApply>>, TError,{data: CommissionReconcileApply}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commissionApply>>, TError,{data: CommissionReconcileApply}, TContext> => {

const mutationKey = ['commissionApply'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commissionApply>>, {data: CommissionReconcileApply}> = (props) => {
          const {data} = props ?? {};

          return  commissionApply(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommissionApplyMutationResult = NonNullable<Awaited<ReturnType<typeof commissionApply>>>
    export type CommissionApplyMutationBody = CommissionReconcileApply
    export type CommissionApplyMutationError = HTTPValidationError

    /**
 * @summary Apply
 */
export const useCommissionApply = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commissionApply>>, TError,{data: CommissionReconcileApply}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commissionApply>>,
        TError,
        {data: CommissionReconcileApply},
        TContext
      > => {
      return useMutation(getCommissionApplyMutationOptions(options), queryClient);
    }
